const faqs = [
  {
    question: "Does Arizona have its own regional passport agency?",
    answer:
      "No, Arizona does not have a regional passport agency within the state. The nearest options are the Los Angeles Passport Agency, San Diego Passport Agency, and Denver Passport Agency. Many Arizona travelers find that using an approved courier like Fast Passport Center is far more convenient than making the long drive to California or Colorado.",
  },
  {
    question: "How fast can I get a passport in Arizona?",
    answer:
      "With Fast Passport Center's courier service, Arizona travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Arizona?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, county clerk, or public library). Renewals for adults can usually be done by mail without an in-person visit. Arizona has hundreds of acceptance facilities across the state.",
  },
  {
    question: "Which Arizona airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Major Arizona international airports include Phoenix Sky Harbor (PHX), Tucson International (TUS), and Phoenix-Mesa Gateway (AZA).",
  },
  {
    question: "Can I renew by mail from Arizona?",
    answer:
      "Yes, if your most recent passport was issued when you were 16 or older, is undamaged, was issued within the last 15 years, and has your current name (or you can provide legal name change documentation). Mail your renewal application to the National Passport Processing Center.",
  },
  {
    question: "Where is the best place to get a passport photo in Arizona?",
    answer:
      "CVS, Walgreens, and Walmart offer walk-in passport photo services at most Arizona locations. The UPS Store and FedEx Office also provide photos and can handle overnight shipping of your application documents in the same visit. Always confirm the photo meets State Department requirements before submitting.",
  },
];

export { faqs };

export default function ArizonaFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Arizona Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Arizona.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}